<ng-container *ngIf="!currentReview && !entitySelected">
  <h2 mat-dialog-title>Post Rating and Review</h2>
  <mat-dialog-content>
    <p>Please select the entity and features that your review is about.  You can review each entity separately.</p>
    <p>
      <mat-radio-group [(ngModel)]="chosenEntity" class="write-review__radio-group" required #radioGroup="matRadioGroup">
        <ng-container *ngIf="airportEntities.length > 0">
          <span class="write-review__entity-container"><span class="write-review__entity-type">Airport:</span> <span class="write-review__entity-description">(Runways and Taxiways, Markings and Signage, Ground Transportation, etc.)</span></span>
          <mat-radio-button *ngFor="let entity of airportEntities" class="write-review__radio-button" [value]="entity">{{entity.name}}</mat-radio-button>
        </ng-container>
        <ng-container *ngIf="FBOEntities.length > 0">
          <span class="write-review__entity-container"><span class="write-review__entity-type">FBO(s):</span> <span class="write-review__entity-description">(Customer Service, Facilities, Line Services, etc.)</span></span>
          <mat-radio-button *ngFor="let entity of FBOEntities" class="write-review__radio-button" [value]="entity">{{entity.name}}</mat-radio-button>
        </ng-container>
        <ng-container *ngIf="businessEntities.length > 0">
          <span class="write-review__entity-container"><span class="write-review__entity-type">Other Businesses:</span> <span class="write-review__entity-description">(Customer Service, Facilities, Available Services, etc.)</span></span>
          <mat-radio-button *ngFor="let entity of businessEntities" class="write-review__radio-button" [value]="entity">{{entity.name}}</mat-radio-button>
        </ng-container>
        <ng-container *ngIf="flyingClubEntities.length > 0">
          <span class="write-review__entity-container"><span class="write-review__entity-type">Flying Clubs:</span> <span class="write-review__entity-description">(Aircraft, Community and Social, Facilities, etc.)</span></span>
          <mat-radio-button *ngFor="let entity of flyingClubEntities" class="write-review__radio-button" [value]="entity">{{entity.name}}</mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close class="aopa-mat-btn aopa-mat-btn--outlined">Cancel</button>
    <button mat-button cdkFocusInitial class="aopa-mat-btn aopa-mat-btn--outlined" [disabled]="!chosenEntity" (click)="selectEntity()">Next</button>
  </mat-dialog-actions>
</ng-container>
<ng-container *ngIf="currentReview || entitySelected">
<form #form="ngForm" (ngSubmit)="submitForm(form.value)" class="write-review__form">
  <h2 mat-dialog-title>Post Rating and Review</h2>
  <mat-dialog-content>
    <p>Please note that you can only post a single rating and review per entity, but you can always return here
    to modify your entries.</p>

    <!-- <p>You are rating and reviewing:
        <mat-select [(ngModel)]="selectedEntity" name="entity" class="write-review__select" (change)="selectChange($event)">
          <mat-option *ngFor="let entity of entities" [value]="entity">
            {{entity.name}}
          </mat-option>
        </mat-select>
    </p> -->
    <p *ngIf="selectedEntity.type === 'Airport'; else businessPlaceholder">Please note you will be posting a
      rating and/or review for the <b>{{selectedEntity.name}}</b> airport itself. Typically airport reviews and ratings pertain to the condition of
      the runways, taxiways, signage, and lighting and your experience with the controllers.</p>

    <h3>Ratings:</h3>
    <!-- <div class="write-review__rating" *ngIf="ratingValue; else newRatingPlaceholder">
      <star-rating-comp   [starType]="'svg'"
                           [staticColor]='"ok"'
                           [hoverEnabled]="true"
                           [rating]="ratingValue"
                           (onClick)="onClick($event)">
      </star-rating-comp>
    </div> -->

    <div class="write-review__rating">
      <span class="write-review__rating-header-overall">Overall*:</span>
      <star-rating   [starType]="'svg'"
                          [rating]="ratingValue"
                          [staticColor]='"ok"'
                          [hoverEnabled]="true"
                          (starClickChange)="onRatingClick($event)">
      </star-rating>
    </div>
    <div class="write-review__rating-horizontal">
      <div class="write-review__rating" *ngFor="let subCat of tempSubRatings; let i = index">
        <span class="write-review__rating-header">{{ subCat.feature }}:</span>
        <star-rating
          [starType]="'svg'"
          [rating]="subCat.rating"
          [staticColor]='"ok"'
          [hoverEnabled]="true"
          (starClickChange)="onSubRatingClick($event,i)">
        </star-rating>
      </div>
    </div>

    <!-- (onRatingChange)="onRatingChange($event)"
 (onHoverRatingChange)="onHoverRatingChange($event)"> -->


    <!-- <p>onHoverRatingChangeResult: {{onHoverRatingChangeResult | json}}</p>
    <p>onClickResult: {{onClickResult | json}}</p>
    <p>onRatingChangeResult: {{onRatingChangeResult | json}}</p> -->

    <h3>Review:</h3>
    <p>Please provide your review for <b>{{selectedEntity.name}}</b>:</p>
    <h4>Title:</h4>
    <p>
      <mat-form-field hintLabel="Max 50 characters" class="write-review__title">
        <input matInput #title maxlength="50" name="reviewTitleField" [(ngModel)]="reviewTitle" />
        <mat-hint align="end">{{title.value?.length || 0}}/50</mat-hint>
      </mat-form-field>
    </p>
    <h4>Text:</h4>
    <p>
      <mat-form-field hintLabel="Max 2000 characters" class="write-review__textarea">
        <textarea matInput #review maxlength="2000" name="reviewField" [(ngModel)]="reviewText"></textarea>
        <mat-hint align="end">{{review.value?.length || 0}}/2000</mat-hint>
      </mat-form-field>
    </p>
    <h4>Images (up to 3):</h4>
    <div class="write-review__images-container">
      <!-- <button id="addImageButton" (click)="openAddImageDialog()" mat-mini-fab *ngIf="galleryImages && galleryImages.length < 3">
        <mat-icon aria-label="Add Image">add</mat-icon>
      </button> -->
      <mat-icon *ngIf="galleryImages && galleryImages.length < 3" (click)="openAddImageDialog()" class="add-icon" mat-tooltip="Add" aria-label="Add Image">add_circle</mat-icon>
      <span class="write-review__images-spacer" *ngIf="galleryImages && galleryImages.length < 3"></span>
      <ngx-gallery *ngIf="galleryImages && galleryImages.length" [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
    </div>
    <div class="write-review__images-deletebar" *ngIf="galleryImages && galleryImages.length >= 1">
      <span class="write-review__images-delete-spacer" *ngIf="galleryImages && galleryImages.length < 3"></span>
      <span class="write-review__images-delete-image" *ngFor="let image of galleryImages; let i = index">
        <mat-icon (click)="deleteImage(i)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete Image">delete_outline</mat-icon>
      </span>
    </div>

    <p class="write-review__name-warning">Note: your first name and last initial will appear with your rating/review.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button *ngIf="newReview" mat-button type="button" class="aopa-mat-btn aopa-mat-btn--outlined" (click)="resetChosen()">Back</button>
    <button mat-button type="submit" cdkFocusInitial class="aopa-mat-btn aopa-mat-btn--outlined">Post</button>
    <button mat-button mat-dialog-close class="aopa-mat-btn aopa-mat-btn--outlined" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
  <ng-template #businessPlaceholder>
    <p>Please note you will be posting a rating and/or review for <b>{{selectedEntity.name}}</b>.  Typically business reviews and ratings
      pertain to your experience with the employees of that business and the prices of services.</p>
  </ng-template>
</form>
</ng-container>
